<template>
  <khrc-navbar/>
  <data-science-details-component-vue />
</template>

<script>
import DataScienceDetailsComponentVue from "@/components/DataScienceDetailsComponent.vue";
import KhrcNavbar from "@/components/KhrcNavbar.vue";
export default {
  components: {
    KhrcNavbar,
    DataScienceDetailsComponentVue,
  },
};
</script>

<style></style>
